import { useLenis } from '@/hooks/useLenis';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { RevealOnScroll, MaskedLine } from '@/components/Motion';

const chapters = [
    {
        num: '01',
        title: 'دليل مُنسّق يدويًا',
        body: 'لا نعرض كل شيء. نراجع كل منصّة استطلاعات قبل إضافتها — المكافأة، الوقت المطلوب، ومصداقية الدفع. ما تراه هنا هو ما نثق به فعلًا.',
    },
    {
        num: '02',
        title: 'الشفافية أولًا',
        body: 'كل رابط ينقلك مباشرة إلى المنصّة الأصلية. نحن دليل، لا وسيط. معاملاتك ومكافآتك تحدث بينك وبين المنصّة بشفافية كاملة.',
    },
    {
        num: '03',
        title: 'وقتك ثمين',
        body: 'صمّمنا هذا الموقع ليكون سريعًا وواضحًا. بلا إعلانات مزعجة، بلا وعود مبالغ فيها. فقط أفضل الاستطلاعات المدفوعة في مكان واحد.',
    },
];

export default function About() {
    useLenis();
    return (
        <div className="grain relative bg-sand-100 text-ink min-h-screen" data-testid="about-page">
            <Navbar />
            <main>
                {/* Hero */}
                <section className="pt-40 pb-20 max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24">
                    <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] mb-10 text-ink-600">
                        <span className="w-8 h-px bg-ink-600" />
                        <span>عن المنصة</span>
                    </div>
                    <h1 className="font-display font-black text-[12vw] md:text-[7vw] leading-[1] tracking-tight">
                        <span className="block">
                            <MaskedLine delay={0.2}>دليلٌ عربي</MaskedLine>
                        </span>
                        <span className="block italic font-light text-emerald-signal">
                            <MaskedLine delay={0.4}>للاستطلاعات المدفوعة</MaskedLine>
                        </span>
                    </h1>
                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, delay: 0.9, ease: [0.16, 1, 0.3, 1] }}
                        className="mt-12 text-lg md:text-xl text-ink-600 leading-relaxed max-w-2xl"
                    >
                        نحن منصّة عربية مستقلّة تجمع أفضل مواقع الاستطلاعات المدفوعة في مكان واحد،
                        بعد مراجعة كل منها يدويًا. هدفنا بسيط: أن نوفّر عليك الوقت ونساعدك على
                        الوصول لفرص حقيقية موثوقة.
                    </motion.p>
                </section>

                {/* Chapters */}
                {chapters.map((c, i) => (
                    <div key={i} className="border-t border-ink/20">
                        <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24 py-16 md:py-20 grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
                            <RevealOnScroll className="lg:col-span-2">
                                <div className="font-display font-black text-6xl md:text-7xl text-emerald-signal">
                                    {c.num}
                                </div>
                            </RevealOnScroll>
                            <RevealOnScroll delay={0.1} className="lg:col-span-6">
                                <h2 className="font-display font-black text-3xl md:text-4xl mb-4 leading-tight">
                                    {c.title}
                                </h2>
                            </RevealOnScroll>
                            <RevealOnScroll delay={0.15} className="lg:col-span-4">
                                <p className="text-ink-600 leading-relaxed">{c.body}</p>
                            </RevealOnScroll>
                        </div>
                    </div>
                ))}

                {/* CTA */}
                <section className="border-t border-ink/20 py-24 text-center">
                    <RevealOnScroll>
                        <h2 className="font-display font-black text-4xl md:text-6xl tracking-tight mb-8">
                            جاهز للبدء؟
                        </h2>
                        <Link
                            to="/surveys"
                            className="hover-arrow inline-flex items-center gap-3 px-8 py-4 bg-ink text-sand-100 text-sm font-medium hover:bg-emerald-signal hover:text-ink transition-colors duration-500"
                            data-testid="about-cta-surveys"
                        >
                            تصفح الاستطلاعات
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M13 7L1 7M1 7L7 1M1 7L7 13" stroke="currentColor" strokeWidth="1.5" />
                            </svg>
                        </Link>
                    </RevealOnScroll>
                </section>
            </main>
            <Footer />
        </div>
    );
}
